import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { db } from "../Config/Firebase"; // Config Pth
import { collection, query, where, getDocs } from "firebase/firestore";
export default function FeastAuth() {

const [email, setEmail] = useState(""); 
const [password, setPassword] = useState("");
  const navigate = useNavigate();

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0,
      v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

const handleLogin = async (e) => {
    e.preventDefault();

    try {
     
      const q = query(
        collection(db, "adminAccounts"),
        where("email", "==", email),
        where("password", "==", password)
      );

      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        // success
        const adminData = querySnapshot.docs[0].data();

        const token = generateUUID();
        localStorage.setItem("authToken", token);
        localStorage.setItem("UserName", adminData.userName || "Admin");

        navigate("/");
      } else {
        alert("Invalid username or password ");
      }
    } catch (error) {
      console.error("Login Error:", error);
      alert("Something went wrong, try again!");
    }
  };


  return (
    <div className="relative flex h-screen font-sans">
      {/* Left Side */}
      <div className=" bg-red-500 flex justify-center items-center text-white  Login-left-side">
        <div className="">
          <div>
            <h1 className="text-6xl font-bold">Heshe</h1>
            <p className="text-lg mt-2">Stop waiting for the right time. Start meeting the right people, right now</p>
          </div>
          
        </div>
      </div>

      {/* Right Side */}
      <div className="flex justify-center Login-right-side">
        <div className="  p-10 mt-16 w-auto">
          <h1 className="text-red-600 text-5xl font-bold mb-2 text-center">Heshe</h1>
          <p className="text-lg mt-2 mb-10">Stop waiting for the right time. Start meeting the right people, right now</p>

          <h2 className="text-xl font-semibold mt-8 mb-10 text-center">Admin Credentials</h2>

          <form className="flex flex-col space-y-8">
            <input
              type="text"
              placeholder="User Name"
              className="border text-black rounded-lg px-4 py-2 focus:ring-2 focus:ring-red-500 text-left outline-none"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="password"
              placeholder="Password"
              className="border rounded-lg text-black px-4 py-2 focus:ring-2 focus:ring-red-500 text-left outline-none"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <button
              type="button"
              onClick={handleLogin}
              className="bg-red-600 text-white w-full py-2 rounded-lg font-semibold hover:bg-red-700 transition"
            >
              Login
            </button>
          </form>
        </div>
      </div>

      
      
    </div>
  );
}
